<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import { localizeLegacyActivityContent } from 'shared/helpers/activityContent';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, createdAt } = useMessageContext();
const { locale } = useI18n();

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'M月d日 HH:mm')
);
const displayContent = computed(() =>
  localizeLegacyActivityContent(content.value, locale.value)
);
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="px-3 py-1 !rounded-xl flex min-w-0 items-center gap-2"
    data-bubble-name="activity"
  >
    <span v-dompurify-html="displayContent" :title="displayContent" />
  </BaseBubble>
</template>
